<template>
    <div>
        <new-methods-component @submitNewMethod="handleSubmitNewMethod" :newMethod="newMethod"></new-methods-component>
    </div>
</template>


<script>
import NewMethodsComponent from '@/components/method/NewMethodsComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "NewMethod",
    components: {NewMethodsComponent},
    data: function () {
        return {
            component_url: 'experiments/methods',
            newMethod: {
                analytes:[]
            },
        }
    },
    mounted: function() {
        this.setBreadcrumb()       
    },

    computed: {
        ...mapGetters ([
            'base_url', 'auth_header'
        ])
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        handleSubmitNewMethod: function(newMethod) {
            var dummy = {}
            //convert files to base64
            var reader1 = new FileReader()
            reader1.readAsDataURL(newMethod.method_file || new Blob([JSON.stringify(dummy)], {type : 'application/json'}))
            reader1.onloadend = () => {
                var base64Str = reader1.result
                if (base64Str.includes('application/json')){
                    delete newMethod.method_file
                }
                else {
                    var indexOfComma = base64Str.indexOf(',');
                    newMethod.method_file = base64Str.slice(indexOfComma+1)
                }
                //method description file
                var reader2 = new FileReader()
                reader2.readAsDataURL(newMethod.method_description_file || new Blob([JSON.stringify(dummy)], {type : 'application/json'}))
                reader2.onloadend = () => {
                    var base64Str = reader2.result
                    if (base64Str.includes('application/json')){
                        delete newMethod.method_description_file
                    }
                    else {
                        var indexOfComma = base64Str.indexOf(',');
                        newMethod.method_description_file = base64Str.slice(indexOfComma+1)
                    }

                    console.log("creating methods", newMethod)

                    axios
                        .post(
                            this.base_url + this.component_url,
                            newMethod,
                            { 
                                headers: this.auth_header
                            }
                        )
                        .then(() => {
                            console.log("Analytical method Successfully Created");
                            this.loading = false;
                            this.$toast.open({
                                duration: 5000,
                                message: `Analytical method Successfully Created`,
                                position: 'is-top',
                                type: 'is-primary'
                            })
                            this.$router.push({ name: "Methods", params: {  } });
                        })
                        .catch(error => {
                            this.loading = false;
                            this.$toast.open({
                                duration: 5000,
                                message: `Analytical method was not successfully Created`,
                                position: 'is-top',
                                type: 'is-danger'
                            })
                            console.log("Analytical method was not successfully Created", error.response.data);
                        });
                }
                reader2.onerror = function (error) {
                    console.log('Error converting to base64: ', error);
                } 
            }
            reader1.onerror = function (error) {
                console.log('Error converting to base64: ', error);
            } 
        }
    }
}
</script>
